import React from 'react';

import RichText from 'dpl/prismic/components/RichText';
import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';

export default function PullQuoteWide({ content }) {
  return (
    <div className="PrismicPullQuoteWide f4 fw-medium">
      &ldquo;{RichText.asText(content)}&rdquo;
    </div>
  );
}

PullQuoteWide.propTypes = {
  content: StructuredTextPropTypes.isRequired
};
